import React from "react";
import { Layout, Menu, Row, Typography, Switch } from "antd";
import MenuSearchBar from "./MenuSearchBar";
import logo from "../assets/images/openfactor-ring(32).png";
import { SearchOutlined } from "@ant-design/icons";

const { Sider } = Layout;
const { Text } = Typography;

export default function SiderMenuComp(props) {
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={props.collapsed}
      style={{
        paddingTop: "1%",
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
      }}
      theme="dark"
    >
      <div
        style={{
          height: props.logoDimensions,
          width: props.logoDimensions,
          marginRight: "auto",
          marginLeft: "auto",
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{
            height: props.logoDimensions,
            marginRight: "auto",
            marginLeft: "auto",
          }}
        />
      </div>
      <div hidden={props.menuSearchBarState}>
        <MenuSearchBar
          colorBgContainer={props.colorBgContainer}
          colorBorder="transparent"
          colorTextPlaceholder="#575757"
        />
      </div>
      <div
        hidden={props.menuSearchIconState}
        style={{
          width: 18,
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: 18,
          marginBottom: 10,
        }}
      >
        <SearchOutlined style={{ color: "white", fontSize: "18px" }} />
      </div>
      <Menu
        theme={props.theme}
        mode="vertical"
        defaultSelectedKeys={props.defaultSelectedKeys}
        items={props.items}
        onClick={props.onClick}
      />
      <Row
        style={{
          marginTop: "100%",
          marginLeft: "10%",
          justifyContent: "flex-start",
        }}
      >
        <div style={{ width: "60%" }} hidden={props.switchLabelState}>
          <Text style={{ color: props.switchLabelColor, marginRight: "20%" }}>
            {props.switchLabel}
          </Text>
        </div>
        <Switch style={{ width: "20%" }} onClick={props.onSwitchClick} />
      </Row>
    </Sider>
  );
}
